import styled from 'styled-components';
import {dFlex, alignCenter, justifyBetween, dFlexColumn} from '../../../globalVariables/GlobalFlex';
import {BGImageCenter, ellipsisLines} from '../../../globalVariables/GlobalVariables';
import {popUpBody} from '../../../component/newPopup/mobilePopup/MobilePopup.css';
import {getToken, getPrimitive, getSpacing, getFontSize, getFontWeight} from '@tickchak/react-share/app';

export const popupWrapper = styled.div<{rowImage?: string}>`
    position: relative;
    height: 100%;
    ${popUpBody}{
        min-height: 100px;
        overflow: visible;
        &::before {
            content: '';
            position: absolute;
            inset-block-start: -50px;
            inset-inline-start: calc(50% - 50px);
            width: 100px;
            height: 100px;
            border-radius: 5px;
            ${p => BGImageCenter(p.rowImage || '', 'cover')}
        }
    }
`;

export const headerActions = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: ${getSpacing('spaceMd')};
    padding-inline: ${getSpacing('spaceLg')};
`;

export const container = styled.div`
    padding: ${getSpacing('spaceLg')};
    width: 100%;
`;

export const subtitle = styled.div`
    font-size: ${getFontSize('caption')};
    color: ${getToken('color.text.secondary')};
    margin-bottom: ${getSpacing('spaceLg')};
`;

export const detailsGrid = styled.div`
    ${dFlexColumn}
    padding-top: ${getSpacing('spaceLg')};
    margin-bottom: ${getSpacing('spaceXl')};
`;

export const detailItem = styled.div`
    ${dFlex}
    gap: ${getSpacing('spaceMd')};
    padding: ${getSpacing('spaceMd')} 0;
    border-bottom: 0.5px solid ${getPrimitive('blackAlphas.black05')};
    &:last-child {
        border-bottom: none;
    }
`;
export const title = styled.div`
    margin-top: ${getSpacing('spaceSm')};
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('h3')};
    color: ${getToken('color.text.default')};
    ${ellipsisLines(2)}
    flex: 1;
    min-width: 200px;
`;
export const label = styled.span`
    font-weight: ${getFontWeight('regular')};
    font-size: ${getFontSize('body')};
    color: ${getToken('color.text.default')};
`;

export const value = styled.span`
    font-weight: ${getFontWeight('bold')};
    font-size: ${getFontSize('body')};
    color: ${getToken('color.text.default')};
    ${ellipsisLines(1)}
`;

export const actionsSection = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyBetween}
    gap: ${getSpacing('spaceMd')};
    padding-top: ${getSpacing('spaceLg')};
    
    .counts {
        margin-inline-start: ${getSpacing('spaceSm')};
        color: ${getPrimitive('solids.white')};
        background-color: ${getPrimitive('reds.red400')};
        padding-inline: ${getSpacing('spaceSm')};
        border-radius: var(--radius-lg);
    }
`;
